'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, TrendingUp } from 'lucide-react';
import Link from 'next/link';
import { cn } from '@/lib/utils';
interface Pillar {
  href: string;
  icon?: typeof TrendingUp;
  title: string;
  description: string;
  cta: string;
  /** Tailwind classes tuned per pillar accent colour. */
  accent: {
    glow: string;
    border: string;
    iconWrap: string;
    iconGlow: string;
    cta: string;
    rule: string;
  };
}
const PILLARS: Pillar[] = [{
  href: '/demand',
  icon: TrendingUp,
  title: 'Create and Convert Demand',
  description: 'Get inspired, learn and take action to boost awareness, drive trial, and convert interest to purchases.',
  cta: 'Demand Central',
  accent: {
    glow: 'from-primary-500/25 via-orange-500/10 to-transparent',
    border: 'group-hover:border-primary-400/50',
    iconWrap: 'bg-primary-500/15 text-primary-300 ring-primary-400/25 group-hover:bg-primary-500/25 group-hover:ring-primary-400/50',
    iconGlow: 'bg-primary-500/40',
    cta: 'text-primary-300 group-hover:bg-primary-500 group-hover:text-white ring-primary-400/40 group-hover:ring-primary-500',
    rule: 'via-primary-400/60'
  }
}
// {
//   href: '/export',
//   icon: Globe,
//   title: 'Global Demand: Export to the World',
//   description:
//     'Assess if export is right for you, your readiness, identify the right markets, build a plan, and execute with the support of experts and partners in NZ and in-market.',
//   cta: 'Export Central',
//   accent: {
//     glow: 'from-blue-500/25 via-cyan-500/10 to-transparent',
//     border: 'group-hover:border-blue-400/50',
//     iconWrap:
//       'bg-blue-500/15 text-blue-300 ring-blue-400/25 group-hover:bg-blue-500/25 group-hover:ring-blue-400/50',
//     iconGlow: 'bg-blue-500/40',
//     cta: 'text-blue-300 group-hover:text-white group-hover:bg-blue-500 ring-blue-400/40 group-hover:ring-blue-500',
//     rule: 'via-blue-400/60',
//   },
// },
];
export function DemandExportHeroSection() {
  const $ = _c(2);
  const isSinglePillar = PILLARS.length === 1;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="pointer-events-none absolute inset-0" aria-hidden="true"><div className="absolute -left-32 -top-40 h-[26rem] w-[26rem] rounded-full bg-primary-500/20 blur-[110px]" /><div className="absolute -bottom-48 -right-32 h-[30rem] w-[30rem] rounded-full bg-orange-500/15 blur-[110px]" /><div className="absolute left-1/2 top-0 h-72 w-[48rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/[0.06] blur-3xl" /><div className="absolute inset-0 opacity-[0.14] [background-image:linear-gradient(to_right,rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.5)_1px,transparent_1px)] [background-size:64px_64px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_40%,black,transparent)]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="relative isolate overflow-hidden bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 py-10 sm:py-14 lg:py-20">{t0}<div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8"><div className={cn("grid grid-cols-1 gap-6", isSinglePillar ? "mx-auto max-w-6xl" : "lg:grid-cols-2 lg:gap-8")}>{PILLARS.map(t2 => {
            const {
              href,
              icon: Icon,
              title,
              description,
              cta,
              accent
            } = t2;
            return <Link key={href} href={href} className={cn("group relative flex cursor-pointer flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.045] p-8 text-left transition-all duration-300 sm:p-10 lg:p-12", "hover:-translate-y-1 hover:bg-white/[0.07] hover:shadow-2xl hover:shadow-black/40", accent.border)}><span aria-hidden="true" className={cn("pointer-events-none absolute -right-16 -top-24 h-64 w-64 rounded-full bg-gradient-to-br opacity-70 blur-3xl transition-opacity duration-300 group-hover:opacity-100", accent.glow)} /><span aria-hidden="true" className={cn("pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent to-transparent", accent.rule)} /><div className={cn("relative z-10 flex flex-1 flex-col", isSinglePillar && "lg:grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-center lg:gap-16")}><div>{Icon && <div className={cn("relative flex h-12 w-12 items-center justify-center rounded-2xl ring-1 transition-all duration-300 sm:h-14 sm:w-14", accent.iconWrap)}><span aria-hidden="true" className={cn("absolute inset-2 rounded-xl opacity-30 blur-md", accent.iconGlow)} /><Icon className="relative h-6 w-6 sm:h-7 sm:w-7" aria-hidden="true" /></div>}<h2 className="mt-6 max-w-xl text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h2></div><div className={cn("mt-6", isSinglePillar && "lg:mt-0")}><p className="max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg sm:leading-8">{description}</p><span className={cn("mt-8 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-base font-bold ring-1 transition-all duration-300 sm:text-lg", accent.cta)}>{cta}<ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" /></span></div></div></Link>;
          })}</div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}